/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update the base appointment duration unit
 * @export
 * @interface AppointmentBaseDurationRequest
 */
export interface AppointmentBaseDurationRequest {
    /**
     * base unit to define appointments duration (all appointments durations will be a multiple of this value)
     * @type {number}
     * @memberof AppointmentBaseDurationRequest
     */
    baseAppointmentDurationInMinutes?: number;
}

/**
 * Check if a given object implements the AppointmentBaseDurationRequest interface.
 */
export function instanceOfAppointmentBaseDurationRequest(value: object): value is AppointmentBaseDurationRequest {
    return true;
}

export function AppointmentBaseDurationRequestFromJSON(json: any): AppointmentBaseDurationRequest {
    return AppointmentBaseDurationRequestFromJSONTyped(json, false);
}

export function AppointmentBaseDurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentBaseDurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseAppointmentDurationInMinutes': json['baseAppointmentDurationInMinutes'] == null ? undefined : json['baseAppointmentDurationInMinutes'],
    };
}

export function AppointmentBaseDurationRequestToJSON(json: any): AppointmentBaseDurationRequest {
    return AppointmentBaseDurationRequestToJSONTyped(json, false);
}

export function AppointmentBaseDurationRequestToJSONTyped(value?: AppointmentBaseDurationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'baseAppointmentDurationInMinutes': value['baseAppointmentDurationInMinutes'],
    };
}

